import $ from 'jquery'

var error = function() {

  function error() {
    $('.error-stamp').each(function(i) {

      var stamp = $(this);

      setTimeout(function() {
        stamp.addClass('active');
     }, i * 600);
    });
  }

  if ($('.body-wrapper__error').length > 0) {
    $('.header').removeClass('nav-up').addClass('nav-down');
    error();
  }

}

module.exports = error;



// WEBPACK FOOTER //
// ./resources/assets/js/modules/error.js